// Auto-generated from BreakoutRegistry.sol/BreakoutRegistry.json
// Do not edit manually - run 'bun run generate:abi' to regenerate

export const breakoutRegistryAbi = [
	{
		type: "constructor",
		inputs: [
			{
				name: "owner_",
				type: "address",
				internalType: "address",
			},
			{
				name: "operator_",
				type: "address",
				internalType: "address",
			},
			{
				name: "resolver_",
				type: "address",
				internalType: "address",
			},
			{
				name: "treasury_",
				type: "address",
				internalType: "address",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "cancelOwnershipHandover",
		inputs: [],
		outputs: [],
		stateMutability: "payable",
	},
	{
		type: "function",
		name: "completeOwnershipHandover",
		inputs: [
			{
				name: "pendingOwner",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [],
		stateMutability: "payable",
	},
	{
		type: "function",
		name: "operator",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "address",
				internalType: "address",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "owner",
		inputs: [],
		outputs: [
			{
				name: "result",
				type: "address",
				internalType: "address",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "ownershipHandoverExpiresAt",
		inputs: [
			{
				name: "pendingOwner",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [
			{
				name: "result",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "renounceOwnership",
		inputs: [],
		outputs: [],
		stateMutability: "payable",
	},
	{
		type: "function",
		name: "requestOwnershipHandover",
		inputs: [],
		outputs: [],
		stateMutability: "payable",
	},
	{
		type: "function",
		name: "resolver",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "address",
				internalType: "address",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "setOperator",
		inputs: [
			{
				name: "newOperator",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "setResolver",
		inputs: [
			{
				name: "newResolver",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "setTreasury",
		inputs: [
			{
				name: "newTreasury",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "transferOwnership",
		inputs: [
			{
				name: "newOwner",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [],
		stateMutability: "payable",
	},
	{
		type: "function",
		name: "treasury",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "address",
				internalType: "address",
			},
		],
		stateMutability: "view",
	},
	{
		type: "event",
		name: "OperatorUpdated",
		inputs: [
			{
				name: "oldOperator",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "newOperator",
				type: "address",
				indexed: true,
				internalType: "address",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "OwnershipHandoverCanceled",
		inputs: [
			{
				name: "pendingOwner",
				type: "address",
				indexed: true,
				internalType: "address",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "OwnershipHandoverRequested",
		inputs: [
			{
				name: "pendingOwner",
				type: "address",
				indexed: true,
				internalType: "address",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "OwnershipTransferred",
		inputs: [
			{
				name: "oldOwner",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "newOwner",
				type: "address",
				indexed: true,
				internalType: "address",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "ResolverUpdated",
		inputs: [
			{
				name: "oldResolver",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "newResolver",
				type: "address",
				indexed: true,
				internalType: "address",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "TreasuryUpdated",
		inputs: [
			{
				name: "oldTreasury",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "newTreasury",
				type: "address",
				indexed: true,
				internalType: "address",
			},
		],
		anonymous: false,
	},
	{
		type: "error",
		name: "AlreadyInitialized",
		inputs: [],
	},
	{
		type: "error",
		name: "NewOwnerIsZeroAddress",
		inputs: [],
	},
	{
		type: "error",
		name: "NoHandoverRequest",
		inputs: [],
	},
	{
		type: "error",
		name: "Unauthorized",
		inputs: [],
	},
	{
		type: "error",
		name: "ZeroAddress",
		inputs: [],
	},
] as const
